import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type FormStore = {
  isLoading: boolean;
  errorMsg: string;
};

const initialState: FormStore = {
  isLoading: false,
  errorMsg: ''
};

export const formSlice = createSlice({
  name: 'form',
  initialState,
  reducers: {
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.errorMsg = action.payload;
    }
  }
});

export const { setIsLoading, setError } = formSlice.actions;

export default formSlice.reducer;
